import { useMediaQuery, useTheme } from "@mui/material";
import { useAuth } from "@sal/authentication.react";
import { type MenuItem } from "@sal/portal";
import { Outlet } from "react-router-dom";
import { MobileNavigation } from "../../components";
import { SecurityContext, SecurityContextPermission } from "../../constants";
import { HorizontalLayout } from "./HorizontalLayout";
import { VerticalLayout } from "./VerticalLayout";
import { LayoutProps } from ".";
import AppSettings from "../../appsettings";
import Box from "@mui/material/Box/Box";

type Auth = ReturnType<typeof useAuth>;

export default function BasePage() {
	const auth = useAuth();
	const theme = useTheme();
	const responsiveBreakpoint = useMediaQuery(theme.breakpoints.down("md"));

	/* Permissions; */
	const hasUserMenuPermission = (auth: Auth) => auth.userHasPermission(SecurityContext.Host, "User_Menu");
	const hasChangePasswordPermission = (auth: Auth) => auth.userHasPermission(SecurityContext.Host, "Change_Password");
	/* Permissions; */

	/* Menu Items; */
	const Icon = ({ className }: { className: string }) => <i className={className} style={{ fontSize: "16px" }} />;

	const menuItems: Array<MenuItem> = [
		{
			label: "Dashboard",
			path: "/Dashboard",
			securityContext: "apI_ContainerTransportImportFCLOrder",
			securityContextPermission: "Read", //TODO: Update with correct security context and permission
			icon: <Icon className="fal fa-table" />
		},
		{
			label: "Users",
			path: "/Users",
			securityContext: "portal_Menu",
			securityContextPermission: "Web_Users",
			icon: <Icon className="fal fa-users" />
		},
		{
			label: "Customers",
			path: "/Customers",
			securityContext: SecurityContext.Contact,
			securityContextPermission: SecurityContextPermission.Customer.Read,
			icon: <Icon className="fal fa-user-group" />
		},
		{
			label: "Locations",
			path: "/Locations",
			securityContext: SecurityContext.Location,
			securityContextPermission: SecurityContextPermission.Location.Read,
			icon: <Icon className="fal fa-earth-americas" />
		}
	];
	/* Menu Items; */

	const Layout: React.ComponentType<LayoutProps> =
		AppSettings?.Layout?.Orientation === "Horizontal" ? HorizontalLayout : VerticalLayout;

	return (
		<Box display="flex" height="100vh" bgcolor="background.default">
			{responsiveBreakpoint ? (
				<Box flexGrow={1} minWidth={0} display="flex" flexDirection="column">
					{auth.isLoggedIn && (
						<Box flexGrow={0}>
							<MobileNavigation
								menuItems={menuItems}
								permissions={{
									userMenu: hasUserMenuPermission,
									changePassword: hasChangePasswordPermission
								}}
							/>
						</Box>
					)}
					<Box
						flexGrow={1}
						overflow="auto"
						sx={{
							scrollbarGutter: "stable"
						}}
					>
						<Outlet />
					</Box>
				</Box>
			) : (
				<Layout menuItems={menuItems} />
			)}
		</Box>
	);
}
